import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
import create from "../../create";
export default create({
  name: "pie",
  computed: {
    labelShow: function labelShow() {
      return this.vaildData(this.option.labelShow, false);
    },
    x2: function x2() {
      return this.option.gridX2 || 20;
    },
    fontSize: function fontSize() {
      return this.option.fontSize || 14;
    }
  },
  methods: {
    updateChart: function updateChart() {
      var _this = this;

      var optionData = this.deepClone(this.dataChart) || [];
      console.log('enter', optionData);
      console.log('enter', this.myChart);
      var option = {
        title: this.ishasprop(this.option.titleShow, {
          text: this.option.title,
          subtext: this.option.subtext || '',
          textStyle: {
            color: this.option.titleColor || '#333',
            fontSize: this.option.titleFontSize || 16
          },
          left: this.option.titlePostion || 'auto',
          subtextStyle: {
            color: this.option.subTitleColor || '#aaa',
            fontSize: this.option.subTitleFontSize || 14
          }
        }, {}),
        tooltip: function () {
          return Object.assign(function () {
            if (_this.formatter) {
              return {
                formatter: function formatter(name) {
                  return _this.formatter(name, _this.dataChart);
                }
              };
            }

            return {};
          }(), {
            textStyle: {
              fontSize: _this.option.tipFontSize,
              color: _this.option.tipColor || "#fff"
            }
          });
        }(),
        grid: {
          left: this.option.gridX || 20,
          top: this.option.gridY || 60,
          right: this.x2,
          bottom: this.option.gridY2 || 60
        },
        legend: {
          show: this.vaildData(this.option.legend, false),
          orient: this.option.legendOrient || "vertical",
          x: this.option.legendPostion || "left",
          top: 0,
          right: this.x2,
          textStyle: {
            fontSize: this.option.legendFontSize || 12
          },
          data: function () {
            return (Array.isArray(optionData) ? optionData : []).map(function (ele, index) {
              return {
                name: ele.name,
                textStyle: _this.ishasprop(!_this.switchTheme, {
                  color: _this.getColor(index, true)
                }, {})
              };
            });
          }()
        },
        series: function () {
          var barColor = _this.option.barColor || [];
          var list = [{
            type: "pie",
            roseType: _this.option.roseType ? "radius" : "",
            radius: _this.option.radius ? ["40%", "55%"] : "50%",
            center: ["50%", "60%"],
            animationType: "scale",
            animationEasing: "elasticOut",
            animationDelay: function animationDelay(idx) {
              return Math.random() * 200;
            },
            label: {
              normal: {
                show: _this.labelShow,
                formatter: '{b}:{c}({d}%)',
                textStyle: {
                  fontSize: _this.fontSize
                }
              }
            },
            data: function () {
              var list = optionData;

              if (_this.option.notCount) {
                list = list.filter(function (ele) {
                  if (ele.value !== 0 && ele.value) {
                    return true;
                  }
                });
              }

              if (_this.option.sort) {
                list.sort(function (a, b) {
                  return a.value - b.value;
                });
              }

              return list;
            }(),
            itemStyle: _this.ishasprop(!_this.switchTheme, {
              color: function color(params) {
                return _this.getColor(params.dataIndex);
              }
            }, {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            })
          }];
          return list;
        }()
      };
      this.myChart.resize();
      this.myChart.setOption(option, true);
    }
  }
});